import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Paper, Slide } from "@mui/material";
import { useTranslation } from "react-i18next";
import IT from "country-flag-icons/react/3x2/IT";
import GB from "country-flag-icons/react/3x2/GB";
import DE from "country-flag-icons/react/3x2/DE";

interface Step0LanguageSelectionProps {
  activeStep: number;
  slideDirection: "left" | "right";
  onLanguageSelect: (code: string) => void;
}

export function Step0LanguageSelection({
  activeStep,
  slideDirection,
  onLanguageSelect,
}: Step0LanguageSelectionProps) {
  const { t } = useTranslation();

  const languages = [
    { code: "it", Flag: IT, label: "Italiano" },
    { code: "en", Flag: GB, label: "English" },
    { code: "de", Flag: DE, label: "Deutsch" },
  ];

  return (
    <Slide
      direction={slideDirection}
      in={activeStep === 0}
      timeout={500}
      unmountOnExit
    >
      <Paper
        elevation={3}
        sx={{
          p: 6,
          bgcolor: "white",
          textAlign: "center",
          position: activeStep === 0 ? "relative" : "absolute",
          width: "100%",
          top: 0,
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: "#333", fontWeight: "bold", mb: 5 }}
        >
          {t("richiestaPreventivo.scegliLingua")}
        </Typography>
        <Box display="flex" justifyContent="center" gap={3} flexWrap="wrap">
          {languages.map(({ code, Flag, label }) => (
            <Paper
              key={code}
              elevation={1}
              onClick={() => onLanguageSelect(code)}
              sx={{
                cursor: "pointer",
                p: 4,
                borderRadius: 2,
                border: "2px solid #e0e0e0",
                transition: "all 0.2s ease",
                minWidth: 130,
                "&:hover": {
                  border: "2px solid #d4a017",
                  boxShadow: 4,
                  transform: "translateY(-4px)",
                },
              }}
            >
              <Box sx={{ width: 80, mx: "auto", mb: 1 }}>
                <Flag style={{ width: "100%", height: "auto" }} />
              </Box>
              <Typography variant="h6" fontWeight="bold" sx={{ color: "#333" }}>
                {label}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Paper>
    </Slide>
  );
}
